var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgIconGuest = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.667 5.004a5 5 0 1 1 8.035 3.974c2.12.948 3.631 2.866 3.631 5.193a.833.833 0 0 1-.833.833H.833A.833.833 0 0 1 0 14.17c0-2.327 1.512-4.245 3.632-5.193a4.992 4.992 0 0 1-1.965-3.974Zm15.833 10h-3.333A.833.833 0 0 0 15 14.17c0-2.327-1.512-4.245-3.632-5.193A5.001 5.001 0 0 0 10 .288a5 5 0 0 1 4.702 8.69c2.12.948 3.631 2.866 3.631 5.193a.833.833 0 0 1-.833.833Z",
    fill: "#000"
  })));
};
export { SvgIconGuest as ReactComponent };
export default __webpack_public_path__ + "a8e50601d0144c685cca96ae0f13234e.svg";